import * as z$1 from "zod/v4";
//#region src/schemas/http/center-agent-direct-message-space.ts
const CENTER_AGENT_DIRECT_MESSAGE_SPACE_KIND = "center_agent_direct_message_space";
const DIRECT_MESSAGE_SPACE_PURPOSE = "openmeld_dm_space";
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const createCenterAgentSessionBodySchema = z$1.strictObject({ creationId: z$1.uuid() });
const centerAgentSessionSelectorSchema = z$1.strictObject({ spaceId: trimmedNonEmptyStringSchema.max(128) });
const centerAgentDirectMessageSpaceProjectionSchema = z$1.strictObject({
	centerAgentProfileId: trimmedNonEmptyStringSchema,
	isCenterAgentDirectMessageSpace: z$1.literal(true),
	kind: z$1.literal(CENTER_AGENT_DIRECT_MESSAGE_SPACE_KIND),
	memberProfileId: trimmedNonEmptyStringSchema,
	organizationId: trimmedNonEmptyStringSchema,
	spaceId: trimmedNonEmptyStringSchema
});
const getCenterAgentDirectMessageSpaceProjectionResponseSchema = z$1.strictObject({
	generatedAt: ISO_DATE_TIME_SCHEMA,
	organizationId: trimmedNonEmptyStringSchema,
	projection: z$1.union([centerAgentDirectMessageSpaceProjectionSchema, z$1.null()])
});
const listCenterAgentSessionsQuerySchema = z$1.strictObject({
	cursor: z$1.string().trim().min(1).max(1024).optional(),
	limit: z$1.number().int().min(1).max(100).default(20)
});
const centerAgentSessionListCursorSchema = z$1.strictObject({
	v: z$1.literal(1),
	organizationId: trimmedNonEmptyStringSchema,
	pairKey: trimmedNonEmptyStringSchema,
	createdAtMs: z$1.number().int().nonnegative(),
	spaceId: centerAgentSessionSelectorSchema.shape.spaceId
});
const centerAgentSessionListItemSchema = centerAgentDirectMessageSpaceProjectionSchema.extend({
	name: z$1.string().nullable(),
	createdAt: ISO_DATE_TIME_SCHEMA.nullable()
});
const listCenterAgentSessionsResponseSchema = z$1.strictObject({
	generatedAt: ISO_DATE_TIME_SCHEMA,
	organizationId: trimmedNonEmptyStringSchema,
	sessions: z$1.array(centerAgentSessionListItemSchema).max(100),
	nextCursor: z$1.string().min(1).max(1024).nullable()
});
function deriveCenterAgentDirectMessageSpaceProjection(input) {
	const centerAgentProfileId = normalizeNonEmptyText(input.centerAgentProfileId);
	if (input.spacePurpose !== DIRECT_MESSAGE_SPACE_PURPOSE || centerAgentProfileId === null) return null;
	const pair = parseDirectMessagePairKey(input.directMessagePairKey);
	if (pair === null || !pair.includes(centerAgentProfileId)) return null;
	const memberProfileId = pair[0] === centerAgentProfileId ? pair[1] : pair[0];
	return {
		centerAgentProfileId,
		isCenterAgentDirectMessageSpace: true,
		kind: CENTER_AGENT_DIRECT_MESSAGE_SPACE_KIND,
		memberProfileId,
		organizationId: input.organizationId,
		spaceId: input.spaceId
	};
}
function isCenterAgentDirectMessageSpaceProjection(input) {
	return deriveCenterAgentDirectMessageSpaceProjection({
		...input,
		organizationId: "projection-check",
		spaceId: "projection-check"
	}) !== null;
}
function parseDirectMessagePairKey(value) {
	const normalized = normalizeNonEmptyText(value);
	if (normalized === null) return null;
	const parts = normalized.split(":").map((part) => part.trim());
	if (parts.length !== 2 || parts.some((part) => part.length === 0)) return null;
	if (parts[0] === parts[1]) return null;
	return parts;
}
function normalizeNonEmptyText(value) {
	if (typeof value !== "string") return null;
	const normalized = value.trim();
	return normalized.length > 0 ? normalized : null;
}
//#endregion
export { centerAgentDirectMessageSpaceProjectionSchema, centerAgentSessionListCursorSchema, centerAgentSessionListItemSchema, centerAgentSessionSelectorSchema, createCenterAgentSessionBodySchema, deriveCenterAgentDirectMessageSpaceProjection, getCenterAgentDirectMessageSpaceProjectionResponseSchema, isCenterAgentDirectMessageSpaceProjection, listCenterAgentSessionsQuerySchema, listCenterAgentSessionsResponseSchema };

//# sourceMappingURL=center-agent-direct-message-space.js.map